
import { format, isBefore } from 'date-fns'
import { defineComponent } from 'vue'
import { mapGetters } from 'vuex'
import AppointmentService from '../common/appointmentService'
import Appointment from '../models/appointment'
export default defineComponent({
  name: 'ManageAppointment',

  data () {
    return {
      appointment: null as unknown as Appointment,
      cancelled: false
    }
  },

  watch: {
    $route: {
      handler (route) {
        AppointmentService.get(route.params.id).then(res => {
          res.data.start = new Date(res.data.start)
          res.data.end = new Date(res.data.end)
          this.appointment = res.data
        })
      },
      immediate: true
    }
  },

  computed: {
    passed (): boolean {
      return isBefore(this.appointment.start, new Date())
    }
  },

  methods: {
    /**
     * Cancel appointment
     */
    cancelAppointment (appointemntId: number) {
      if (confirm('Are you sure you want to cancel this appointment?')) {
        AppointmentService.cancelAppointment(appointemntId).then(res => {
          this.cancelled = true
        })
      }
    },

    /**
     * Formats the given date in the specified format
     */
    formatTime (date: Date, formatString: string): string {
      return format(date, formatString)
    }
  }
})
